<ng-container *ngrxLet="activeLanguage$ as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'pl'">
        <p>
            Polska Agencja Żeglugi Powietrznej zakończyła proces oceny Wstępnych Wniosków złożonych przez uczestników Etapu I konkursu w
            ramach projektu "Rozbudowa i wyposażenie centrów kompetencji (specjalistyczne ośrodki szkoleniowe, wsparcie wdrożeń, centra
            monitorowania) oraz infrastruktura do zarządzania ruchem pojazdów bezzałogowych, jako Ekosystem Innowacji". W wyniku
            przeprowadzonego audytu oraz weryfikacji skorygowanych dokumentów, do udziału w Etapie II zakwalifikowano 33 kandydatów.
        </p>
        <ng-container *ngTemplateOutlet="resultsTableTemlate" />
        <p>
            Komisja Oceny Wniosków (KOW) przeanalizuje i oceni wszystkie Wnioski w ramach Etapu II Konkursu. W ocenie zostaną uwzględnione
            opinie użytkowników systemu KSID (Krajowy System Informacji Dronowej). Na tej podstawie w terminie do dnia 27 sierpnia 2025 r.
            zostaną wyłonieni laureaci, którzy stworzą Centra Kompetencji, zgodnie z § 9 Regulaminu Konkursu.
        </p>
    </ng-container>
    <ng-container *ngIf="activeLanguage === 'en'">
        <p>
            The Polish Air Navigation Services Agency has completed the evaluation process of Preliminary Applications submitted by
            participants of Stage I of the competition as part of the project "Expansion and equipment of competence centers (specialized
            training centers, implementation support, monitoring centers) and infrastructure for managing unmanned vehicle traffic, as an
            Innovation Ecosystem." As a result of the audit and verification of corrected documents, 33 candidates were qualified to
            participate in Stage II.
        </p>
        <ng-container *ngTemplateOutlet="resultsTableTemlate" />
        <p>
            The Application Evaluation Committee (KOW) will analyze and evaluate all Applications as part of Stage II of the Competition.
            The evaluation will take into account the opinions of users of the KSID system (National Drone Information System). Based on
            this, by August 27, 2025, the winners will be selected, who will create Competence Centers, in accordance with § 9 of the
            Competition Regulations.
        </p>
    </ng-container>
</ng-container>
<ng-template #resultsTableTemlate>
    <div class="table-container">
        <table mat-table [dataSource]="results">
            <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef class="col-position">Nr</th>
                <td mat-cell *matCellDef="let element" class="col-position">
                    {{ element.position }}
                </td>
                <td mat-footer-cell *matFooterCellDef class="col-position"></td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="col-name">Nazwa Centrum Kompetencji</th>
                <td mat-cell *matCellDef="let element" class="column">{{ element.name }}</td>
                <td mat-footer-cell *matFooterCellDef class="footer">SUMA</td>
            </ng-container>
            <ng-container matColumnDef="qualified">
                <th mat-header-cell *matHeaderCellDef class="col-value">Zakwalifikowane do etapu&nbsp;II</th>
                <td mat-cell *matCellDef="let element" class="col-value">{{ element.qualified || "" }}</td>
                <td mat-footer-cell *matFooterCellDef class="col-value footer">{{ totalQualified }}</td>
            </ng-container>
            <ng-container matColumnDef="rejected">
                <th mat-header-cell *matHeaderCellDef class="col-value">Odrzucone</th>
                <td mat-cell *matCellDef="let element" class="col-value">{{ element.rejected || "" }}</td>
                <td mat-footer-cell *matFooterCellDef class="col-value footer">{{ totalRejected }}</td>
            </ng-container>
            <ng-container matColumnDef="sum">
                <th mat-header-cell *matHeaderCellDef class="col-value">Łączna liczba wniosków</th>
                <td mat-cell *matCellDef="let element" class="col-value">{{ element.qualified + element.rejected }}</td>
                <td mat-footer-cell *matFooterCellDef class="col-value footer">{{ totalSum }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" [class]="row.qualified ? 'qualified' : 'rejected'"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
    </div>
</ng-template>
